export default __webpack_public_path__ + "static/media/gratitudeCard.d21a49cc.png";